export const OFFER_SPECIFIC_FIELDS = [
  'owner',
  'teamId',
  'status',
  'notes',
  'leadSourceId',
  'leadSourceNameSpecified',
  'contractDate',
  'offerPrice',
  'emdHolderCompanyName',
  'emdAmount',
  'numbersDaysEmdDue',
  'emdDueDate',
  'downPaymentAmount',
  'downPaymentPercentage',
  'releaseOfEarnestMoney',
  'mortgageRatePercentage',
  'terminationFee',
  'sellerPaidClosingCostsAmount',
  'sellerPaidClosingCostsPercentage',
  'financingType',
  'closingDate',
  'proposedClosingTimeframe',
  'contingencies',
  'expirationDate',
  'propertyExclusions',
  'propertyInclusions',
  'isPersonalDeal',
  'isDualAgency',
  'acceptanceDate',
] as const;
